"use client";
import { StaticImageData } from "next/image";
import {
  MotionNextLink,
  MotionNextLinkProps,
  MotionTypography,
} from "@cc/motion-components";
import { MaterialImage } from "@cc/material-components";
import RoomIcon from "@mui/icons-material/Room";
import { H6_2 } from "@theme/components/typography.fontvariant";
import { deepmerge } from "@mui/utils";
import { LinkProps } from "@cc/link";
import { Box } from "@mui/material";

export interface InitiativeListingCardProps
  extends Omit<MotionNextLinkProps, "children"> {
  title?: string;
  href: LinkProps["href"];
  image: StaticImageData | string;
  location?: string;
}

const InitiativeListingCard = (props: InitiativeListingCardProps) => {
  const { title, location, image, href, ...restLinkProps } = props;
  return (
    <MotionNextLink
      href={href}
      {...deepmerge(motionNextLinkProps, restLinkProps)}
    >
      <Box
        sx={{
          width: 1,
          aspectRatio: "1/1",
          overflow: "hidden",
          mb: 2,
        }}
      >
        <MaterialImage
          src={image}
          alt={""}
          width={420}
          height={420}
          sx={{
            width: "100%",
            aspectRatio: "1/1",
            objectFit: "cover",
          }}
        />
      </Box>
      {location && (
        <MotionTypography
          variant="body1"
          color={"primary"}
          sx={{
            alignItems: "center",
            gap: 0.75,
            mb: 1,
            display: "flex",
          }}
        >
          <RoomIcon sx={{ width: { xs: "18px", md: "18px" } }} />
          {location}
        </MotionTypography>
      )}
      {title && (
        <MotionTypography
          variant="h6"
          textTransform={"capitalize"}
          fontSize={H6_2}
          fontWeight={400}
          color={"primary"}
        >
          {title}
        </MotionTypography>
      )}
    </MotionNextLink>
  );
};

export default InitiativeListingCard;

const motionNextLinkProps: Omit<MotionNextLinkProps, "children" | "href"> = {
  whileInView: {
    x: "0",
    opacity: 1,
  },
  transition: {
    duration: 0.5,
  },
  exit: {
    x: "-40%",
    opacity: 0,
  },
  viewport: {
    margin: "0px 0px 0px 100px",
  },
  sx: {
    display: "block",
    textDecoration: "none",
    // width: { xs: 1, xs_sm: 350, lg: 420 },
    width: 1,
    maxWidth: { xs: 1, lg: 420 },
    img: {
      transition: "all 2s",
    },
    "&:hover": {
      img: {
        transform: "scale(1.05)",
      },
    },
  },
};
